import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  htmlContent: null,
  htmlContentSH: null,
  loading: false,
  error: null
};

const statusFileSlice = createSlice({
  name: 'statusFile',
  initialState,
  reducers: {
    setHtmlContent: (state, action) => {
      state.loading = true;
      state.htmlContent = action.payload;
      state.error = null;
      state.loading = false;
    },
    setHtmlContentSH: (state, action) => {
      state.loading = true;
      state.htmlContentSH = action.payload;
      state.error = null;
      state.loading = false;
    },
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    }
  }
});

export const { setHtmlContent,setHtmlContentSH, setLoading, setError } = statusFileSlice.actions;
export default statusFileSlice.reducer;

